import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { QueryParamService } from '../query-param/query-param.service';

@Injectable({
  providedIn: 'root',
})
export class CjAffiliateService {
  private cjevent: string;
  private cjeventid: string;
  private utmSource: string;
  constructor(private route: ActivatedRoute, private queryParamService: QueryParamService) {
    this.cjevent = this.queryParamService.getQueryParam('cjevent');
    this.cjeventid = this.queryParamService.getQueryParam('cjeventid');
    this.utmSource = this.queryParamService.getQueryParam('utm_source');
  }

  /**
   * The cjevent query param is deprecated, so we'll be supporting cjeventid long-term instead.
   * As a precaution we'll check for both cjevent and cjeventid query params.
   */
  get cjEventId(): string {
    return this.cjeventid || this.cjevent;
  }

  /**
   * Conditionally create the CJEVENTID cookie if both utm_source and cjeventid query params are present.
   */
  conditionallySetCookie(): void {
    if (this.cjEventId != null && this.utmSource === 'cj') {
      this.createCookie();
    }
  }

  /**
   * Create the CJEVENTID cookie.
   */
  private createCookie(): void {
    const value = this.cjEventId;
    const expirationLength = 2592000000; // 30 days in milliseconds
    const dateNow = new Date();
    dateNow.setTime(dateNow.getTime() + expirationLength); // Sets expiration time (Time now + 30 days)
    const exp = dateNow.toUTCString();
    document.cookie = `CJEVENTID=${value}; expires=${exp}; path=/; domain=${this.getHostname()}`;
  }

  private getHostname(): string | null {
    try {
      if (typeof window !== 'undefined' && window.location && window.location.hostname) {
        const hostnameParts = window.location.hostname.split('.');
        if (hostnameParts.length >= 2) {
          return hostnameParts.slice(-2).join('.');
        }
        // Handle single-level domains or localhost
        return window.location.hostname;
      }
      return '.aceable.com';
    } catch (error) {
      // Silently handle error
      return '.aceable.com';
    }
  }
}
